import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Validate and sanitize a CSS color value.
 *
 * The regex covers common color formats (hex, rgb[a], hsl[a] and named colors).
 * If the provided value doesn't match, `undefined` is returned so it can be ignored.
 */
export function sanitizeColor(value?: string): string | undefined {
  if (!value) return undefined
  const color = value.trim()
  const cssColorRegex =
    /^(#([0-9a-fA-F]{3,4}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})|rgb(a)?\((\s*\d{1,3}\s*,){2}\s*\d{1,3}\s*(,\s*(0|1|0?\.\d+))?\)|hsl(a)?\((\s*\d{1,3}\s*,){2}\s*\d{1,3}%\s*(,\s*(0|1|0?\.\d+))?\)|[a-zA-Z]+)$/
  return cssColorRegex.test(color) ? color : undefined
}
